import N8nNodeIcon from './NodeIcon.vue';

export default N8nNodeIcon;
